<template>
  <v-app>
    <cabecera/>
    <v-main style="background-color:#6D9886;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />
      <v-container>
        <v-row justify="center">
          <v-col cols="12" lg="8" md="8" sm="12">
            <v-card color="#F2E7D5" elevation="10">
              <v-card-title style="color: #393E46;"><h1 class="text-h4 font-weight-bold">Mis Suscripciones</h1></v-card-title>
              <v-card-subtitle  style="color: #393E46;">Encuentre sus carnets para los clubes que esta suscrito </v-card-subtitle>
              <v-card-text>
                    <v-row>
                      <v-col cols="12" lg="6" md="6" sm="12" v-for="ticket in suscripciones" :key="ticket.id">
                        <v-card color="#393E46" elevation="10">
                          <v-card-title  justify="center" ><h2 >{{ticket.tipoCarnet.tipoCarnetTemporada.temporadaNegocio.negocio}}</h2></v-card-title>
                          <v-card-text >
                            <v-row >
                              <v-col cols="12" lg="6" md="6" sm="6">
                                <p>Tipo de Socio: {{ticket.tipoCarnet.tipoCarnet}}</p>
                                <p>Temporada: {{ticket.tipoCarnet.tipoCarnetTemporada.temporada}}</p>
                              </v-col>
                              <v-col v-if="ticket.estadoCarnet.estadoCarnetId ===2 || ticket.estadoCarnet.estadoCarnetId === 3 || ticket.estadoCarnet.estadoCarnetId === 4" cols="12" lg="6" md="6" sm="6">
                                <v-row>
                                  <v-col cols="10">
                                  <v-btn class="primary" @click="verentrada(ticket)"><v-icon left>
                                  fas fa-qrcode
                                </v-icon>Ver Carnet</v-btn></v-col>
                                </v-row> <v-row> <v-col cols="10">
                                <v-btn class="secondary" @click="verwallet(ticket)"><v-icon left>
                                  fas fa-wallet
                                </v-icon>Ver Wallet</v-btn></v-col></v-row>
                              </v-col>
                              <v-col v-if="ticket.estadoCarnet.estadoCarnetId ===1" cols="12" lg="6" md="6" sm="6">
                                <p>PENDIENTE DE APROBACIÓN</p>
                              </v-col>
                              <v-col v-if="ticket.estadoCarnet.estadoCarnetId ===5" cols="12" lg="6" md="6" sm="6">
                                <p>RECHAZADO</p>
                              </v-col>
                            </v-row>

                          </v-card-text>
                        </v-card>
                      </v-col></v-row>




              </v-card-text>

            </v-card>
          </v-col>

        </v-row>
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
    <piepagina/>
  </v-app>
</template>
<script>

import cabecera from "@/components/general/cabecera";
import piepagina from "@/components/general/piepagina";
import {mapGetters} from "vuex";
import axios from "axios";
import moment from "moment";
import store from "@/store";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";

export default {
  name: 'suscripciones',
  title: 'Mis suscripciones | Tunay Mi acceso de bolsillo',
  components: {
    Cabecerabaja,
    cabecera,
    piepagina,
  },
  data: () => ({
    overlay: false,
    tab: null,
    token:'',
    date1: new Date(),
    suscripciones:[]
  }),
  mounted() {

    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

              this.getTickets()
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })
    }else{
      this.token = firebase.auth().currentUser.auth.currentUser.accessToken;

      this.getTickets()

    }
  },
  watch:{
    '$store.state.usuario': function (){
      this.getTickets()
    }
  },
  methods:{
    getTickets(){
      this.overlay = true
      var bodyFormData = new FormData();

      bodyFormData.append('personaId', this.usuario.id);
      axios.post("membresia/suscripciones",bodyFormData,{
        headers: {
          'Authorization': `Bearer ${this.token}`,
        }
      })
          .then(response=>{
            this.overlay = false
           this.suscripciones = response.data
            })


    },

    verwallet(ticket){
      axios({
        method: 'get',
        url: 'passkit/carnet/'+ticket.socioPrincipal.personaId+'/'+ticket.tipoCarnet.tipoCarnetTemporada.temporadaId,
        responseType: 'arraybuffer'
      })
          .then(response=>{
            const reader = new FileReader();
            const out = new Blob([response.data], {
              type: "application/vnd.apple.pkpass",
            });
            reader.onload = function () {
              if (reader.result !== null) {
                window.location.href = reader.result.toString();
              }
            };
            reader.readAsDataURL(out);
          })
          .catch(() => console.log('error occured'))
    },
    formatDateee(value) {
      return moment(value).locale('es-pe').format("YYYY-MM-DD hh:mm:ss")
    },
    verentrada(ticket){
      store.dispatch("fetchTicket",ticket)
      this.$router.push({ path: '/carnet' });
    },

  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      usuario: "usuario"
    })
  }
}
</script>